var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treeview theme--light"},_vm._l((_vm.items),function(item){return _c('TreeItem',{key:item.id,attrs:{"item":item,"selected":_vm.value,"level":0,"load-children":_vm.loadChildren,"parent-ids":[],"leaf-level":_vm.leafLevel},on:{"select":_vm.onSelect}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }